/**
 * 견적을 내면 «상품/단가 관리» 에 자동으로 등록되는 품목.
 *
 * 서버(`CatalogSyncService`)는 견적 품목 중 카탈로그 품목이면서 내 단가가 아직 없는 것을
 * 견적 단가로 **판매중** 등록한다(이후 자동견적 대상이 된다). 이미 단가가 있는 품목은 견적서
 * 작성 창이 바꿀지 묻고 `updateCatalog` 를 0/1 로 싣는다. 처음 등록되는 품목은 화면에 아무
 * 안내가 없었다(V-11) — 제출 뒤 어떤 품목이 등록됐는지 알려 준다.
 */
export interface CatalogSyncCandidate {
  itemName: string;
  itemId?: string;
  updateCatalog?: number;
}

export function listAutoRegisteredItems(
  items: CatalogSyncCandidate[],
): string[] {
  return items
    .filter((item) => !!item.itemId && item.updateCatalog === undefined)
    .map((item) => item.itemName.trim() || "이름 없는 품목");
}

export function describeAutoRegisteredItems(
  items: CatalogSyncCandidate[],
): { title: string; description: string } | null {
  const names = listAutoRegisteredItems(items);
  if (names.length === 0) return null;
  const [first] = names;
  const label = names.length > 1 ? `${first} 외 ${names.length - 1}개` : first;
  return {
    title: `처음 견적한 품목 ${names.length}개를 내 상품으로 등록했습니다.`,
    description: `${label} — «상품/단가 관리»에 견적 단가로 판매중 등록되어 다음 견적 요청에 자동견적 대상이 될 수 있습니다. 팔지 않을 품목은 판매 상태를 꺼 주세요.`,
  };
}
